<div class="page">
  <app-page-header page-title="home.pageTitle"></app-page-header>
  <div class="page-content">
    <div class="row mb-2" *ngIf="(loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator')">
      <div class="col-6">
        <mat-card>
          <mat-card-content>
            <h5>{{ 'home.serverDiskSpace' | translate : { used: serverDiskUsed } }}</h5>
            <mat-progress-bar [mode]="determinate" [color]="accent" [value]="serverDiskUsed" style="height: 20px;">
            </mat-progress-bar>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="alert alert-warning d-flex" role="alert"
      *ngIf="(loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator') && isNewSuppliersInTank">
      <div>
        <strong>
          {{ 'common.words.warning' | translate }}
        </strong>
        <p>
          {{ 'suppliers.isNewSuppliersInTank' | translate }}
        </p>
      </div>
      <a class="ml-4 align-self-center" mat-stroked-button routerLink="./suppliers/tank">
        Vai a "Serbatoio fornitori"
        <mat-icon fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
      </a>
    </div>
    <div class="alert alert-warning d-flex" role="alert"
      *ngIf="(loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator') && isSuppliersReports">
      <div>
        <strong>
          {{ 'common.words.warning' | translate }}
        </strong>
        <p>
          {{ 'suppliers.isReports' | translate }}
        </p>
      </div>
      <a class="ml-4 align-self-center" mat-stroked-button routerLink="./suppliers/importReport">
        Vai a "Report fornitori"
        <mat-icon fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
      </a>
    </div>
    <div class="alert alert-warning d-flex" role="alert"
      *ngIf="(loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator') && tankDocumentsCount > 0">
      <div>
        <strong>
          {{ 'common.words.warning' | translate }}
        </strong>
        <p>
          {{ 'tank.documentsInTankAlert' | translate: { count: tankDocumentsCount } }}
        </p>
      </div>
      <a class="ml-4 align-self-center" mat-stroked-button routerLink="./tank/list">
        Vai a "Serbatoio documenti"
        <mat-icon fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
      </a>
    </div>
    <div class="alert alert-warning d-flex" role="alert"
      *ngIf="(loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator' || loggedUserRoleType === 'master' || loggedUserRoleType === 'collaborator' || loggedUserRoleType === 'temporary') && lastInsertedDocs > 0">
      <div>
        <strong>
          {{ 'common.words.warning' | translate }}
        </strong>
        <p>
          {{ 'historicalDocs.documentsInsertedAlert' | translate }}
        </p>
      </div>
      <a class="ml-4 align-self-center" mat-stroked-button routerLink="./historical-docs/list">
        Vai agli "Ultimi documenti inseriti"
        <mat-icon fontSet="fal" fontIcon="fa-chevron-right"></mat-icon>
      </a>
    </div>
    <div class="row" *ngIf="loggedUserRoleType !== 'temporary' && loggedUserRoleType !== 'shared'">
      <div class="col-12 col-md-6">
        <mat-card>
          <app-card-spinner [visible]="!loggedUserRoleType || loggedUserRoleType === ''" type="zero"></app-card-spinner>
          <mat-card-title *ngIf="loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator'">
            {{ "home.turnover" | translate }}
          </mat-card-title>
          <mat-card-title *ngIf="masterShowPropertiesArea && (loggedUserRoleType === 'master' || loggedUserRoleType === 'collaborator')">
            {{ "home.documents" | translate }}
          </mat-card-title>
          <mat-card-subtitle>{{ "home.dataUpdated" | translate }} {{ today | date }}</mat-card-subtitle>
          <mat-card-content>
            <div class="chart-container" *ngIf="loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator'">
              <!-- <canvas baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels"
                [chartType]="doughnutChartType" [plugins]="doughnutChartPlugins" [options]="doughnutChartOptions"
                [legend]="doughnutChartLegend" [colors]="doughnutChartColors">
              </canvas> -->
            </div> <!-- /.chart-container -->
            <div *ngIf="masterShowPropertiesArea && (loggedUserRoleType === 'master' || loggedUserRoleType === 'collaborator')">
              <app-card-spinner [visible]="!totDocs" type="zero"></app-card-spinner>
              <div class="row">
                <div class="col-12">
                  <p class="mb-2">
                    <strong>{{ 'properties.documents.totalDocs' | translate }} {{ totDocs }}</strong>
                  </p>
                </div>
                <div class="col-6" *ngIf="!isCompaniesException">
                  <table class="table table-borderless table-striped">
                    <tbody>
                      <tr>
                        <td><strong>{{ "home.mandatoryInserted" | translate }}</strong></td>
                        <td>{{ totalDocs.totInsert }}</td>
                      </tr>
                      <tr>
                        <td><strong>{{ "home.missingRequired" | translate }}</strong></td>
                        <td>{{ totalDocs.totNotInsert }}</td>
                      </tr>
                      <tr>
                        <td><strong>{{ "home.generics" | translate }}</strong></td>
                        <td>{{ totalDocs.totOptional }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row mt-4 mb-5 align-items-center" *ngIf="!isCompaniesException">
                <div class="col-4">
                  <strong>{{ 'home.progressMandatory' | translate }}</strong>
                </div>
                <div class="col-6 ">
                  {{ totalDocs.totNotInsert }} / {{ totalDocs.totMandatory }}
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div> <!-- /.col-12 -->

      <div class="col-12 col-md-6">
        <div class="row" *ngIf="loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator'">
          <div class="col-12 col-md-6">
            <a class="hidden-link" routerLink="./users/list">
              <mat-card class="custom-card stat-card orange-stat">
                <app-card-spinner [visible]="usersCount == undefined" type="zero"></app-card-spinner>
                <mat-card-title>{{ "home.users" | translate }}</mat-card-title>
                <mat-card-content>
                  <mat-icon fontSet="fal" fontIcon="fa-users" class="stat-icon"></mat-icon>
                  <span class=" stat-value">{{ usersCount }}</span>
                </mat-card-content>
              </mat-card>
            </a>
          </div> <!-- /.col -->
          <div class="col-12 col-md-6">
            <a class="hidden-link" routerLink="./companies/list">
              <mat-card class="custom-card stat-card orange-stat">
                <app-card-spinner [visible]="companiesCount == undefined" type="zero"></app-card-spinner>
                <mat-card-title>{{ "home.companies" | translate }}</mat-card-title>
                <mat-card-content>
                  <mat-icon fontSet="fal" fontIcon="fa-industry" class="stat-icon"></mat-icon>
                  <span class=" stat-value">{{ companiesCount }}</span>
                </mat-card-content>
              </mat-card>
            </a>
          </div> <!-- /.col -->
          <div class="col-12 col-md-6">
            <a class="hidden-link" routerLink="./properties/list">
              <mat-card class="custom-card stat-card orange-stat">
                <app-card-spinner [visible]="propertiesCount == undefined" type="zero"></app-card-spinner>
                <mat-card-title>{{ "home.properties" | translate }}</mat-card-title>
                <mat-card-content>
                  <mat-icon fontSet="fal" fontIcon="fa-home" class="stat-icon"></mat-icon>
                  <span class=" stat-value">{{ propertiesCount }}</span>
                </mat-card-content>
              </mat-card>
            </a>
          </div> <!-- /.col -->
          <div class="col-12 col-md-6">
            <a class="hidden-link" routerLink="./deadlines/list/subscriptions">
              <mat-card class="custom-card stat-card orange-stat">
                <app-card-spinner [visible]="subscriptionsCount == undefined" type="zero"></app-card-spinner>
                <mat-card-title>{{ "home.subscriptions" | translate }}</mat-card-title>
                <mat-card-content>
                  <mat-icon fontSet="fal" fontIcon="fa-address-card" class="stat-icon"></mat-icon>
                  <span class=" stat-value">{{ subscriptionsCount }}</span>
                </mat-card-content>
              </mat-card>
            </a>
          </div> <!-- /.col -->
        </div>
        <div class="row" *ngIf="masterShowPropertiesArea && (loggedUserRoleType === 'master' || loggedUserRoleType === 'collaborator')">
          <div class="col-12 col-md-6">
            <a class="hidden-link" routerLink="./properties/list">
              <mat-card class="custom-card stat-card orange-stat">
                <app-card-spinner [visible]="propertiesCount == undefined" type="zero"></app-card-spinner>
                <mat-card-title>{{ "home.properties" | translate }}</mat-card-title>
                <mat-card-content>
                  <mat-icon fontSet="fal" fontIcon="fa-home" class="stat-icon"></mat-icon>
                  <span class=" stat-value">{{ propertiesCount }}</span>
                </mat-card-content>
              </mat-card>
            </a>
          </div>
          <div class="col-12 col-md-6">
            <a class="hidden-link" routerLink="./deadlines/list/documents">
              <mat-card class="custom-card stat-card orange-stat">
                <app-card-spinner [visible]="deadlinesCount == undefined" type="zero"></app-card-spinner>
                <mat-card-title>{{ "home.deadlines" | translate }}</mat-card-title>
                <mat-card-content>
                  <mat-icon fontSet="fal" fontIcon="fa-clock" class="stat-icon"></mat-icon>
                  <span class=" stat-value">{{ deadlinesCount }}</span>
                </mat-card-content>
              </mat-card>
            </a>
          </div>
          <div class="col-12 col-md-6">
            <a class="hidden-link" routerLink="./search-docs/listv2">
              <mat-card class="custom-card stat-card orange-stat">
                <app-card-spinner [visible]="totDocs == undefined" type="zero"></app-card-spinner>
                <mat-card-title>{{ "home.search" | translate }}</mat-card-title>
                <mat-card-content>
                  <mat-icon fontSet="fal" fontIcon="fa-search" class="stat-icon"></mat-icon>
                  <span class=" stat-value">{{ totDocs }}</span>
                </mat-card-content>
              </mat-card>
            </a>
          </div>
          <div class="col-12 col-md-6">
            <a class="hidden-link" routerLink="./tank/list">
              <mat-card class="custom-card stat-card orange-stat">
                <app-card-spinner [visible]="tanksCount == undefined" type="zero"></app-card-spinner>
                <mat-card-title>{{ "home.tank" | translate }}</mat-card-title>
                <mat-card-content>
                  <mat-icon fontSet="fal" fontIcon="fa-fill-drip" class="stat-icon"></mat-icon>
                  <span class=" stat-value">{{ tanksCount }}</span>
                </mat-card-content>
              </mat-card>
            </a>
          </div>
          <div class="col-12 col-md-6" *ngIf="!isCompaniesException">
            <a class="hidden-link" routerLink="./caretakers/list">
              <mat-card class="custom-card stat-card orange-stat">
                <app-card-spinner [visible]="caretakersCount == undefined" type="zero"></app-card-spinner>
                <mat-card-title>{{ "home.caretakers" | translate }}</mat-card-title>
                <mat-card-content>
                  <mat-icon fontSet="fal" fontIcon="fa-chevron-right" class="stat-icon"></mat-icon>
                  <span class=" stat-value">{{ caretakersCount }}</span>
                </mat-card-content>
              </mat-card>
            </a>
          </div>
          <div class="col-12 col-md-6">
            <a class="hidden-link" routerLink="./temporaries/add">
              <mat-card class="custom-card stat-card orange-stat">
                <app-card-spinner [visible]="temporariesCount == undefined" type="zero"></app-card-spinner>
                <mat-card-title>{{ "home.temporaryAdd" | translate }}</mat-card-title>
                <mat-card-content>
                  <mat-icon fontSet="fal" fontIcon="fa-sign-in-alt" class="stat-icon"></mat-icon>
                  <span class=" stat-value">{{ temporariesCount }}</span>
                </mat-card-content>
              </mat-card>
            </a>
          </div>
        </div>
      </div>
      <!-- <div class="col-12 col-md-6">
        <mat-card>
          <mat-card-title *ngIf="loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator'">
            {{ "home.turnover" | translate }}
          </mat-card-title>
          <mat-card-title *ngIf="loggedUserRoleType === 'master'">
            {{ "home.documents" | translate }}
          </mat-card-title>
          <mat-card-subtitle>{{ "home.dataUpdated" | translate }} {{ today | date }}</mat-card-subtitle>
          <mat-card-content>
            <div class="chart-container" *ngIf="lineChartData.length">
              <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels"
                [chartType]="lineChartType" [plugins]="lineChartPlugins"
                [options]="lineChartOptions" [legend]="lineChartLegend"
                [colors]="lineChartColors">
              </canvas>
            </div>
          </mat-card-content>
        </mat-card>
      </div>  /.col-12 -->
    </div>
  </div>
</div>